import LoadingSpinner from '@/components/ui/loading'
import { useAuthContext } from '@/context'
import type { ReactElement, ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

type Props = {
    component: ReactNode
}

const EmailVerifiedRouteWrapper = ({ component }: Props): ReactElement => {
    const location = useLocation()
    const { loggedIn, isLoading, user, isGuest } = useAuthContext()

    if (loggedIn && isLoading) {
        return <LoadingSpinner />
    }

    // Not logged in: let other wrappers decide what to do.
    if (!loggedIn) {
        return <>{component}</>
    }

    // Guest sessions (magic links) don't necessarily have an email to verify.
    if (isGuest) {
        return <>{component}</>
    }

    // If user hasn't loaded yet, avoid redirect loops.
    if (!user) {
        return <LoadingSpinner />
    }

    if (user.email_verified) {
        return <>{component}</>
    }

    const redirectPath = encodeURIComponent(location.pathname + location.search)
    const email = encodeURIComponent(user.email || '')
    return <Navigate to={`/verify-email?email=${email}&redirect_url=${redirectPath}`} replace />
}

export default EmailVerifiedRouteWrapper

